// @ts-nocheck
/**
 * CSRD API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OperationCondition } from './operationCondition';
import { DeterminationType } from './determinationType';
import { BelowLdLq } from './belowLdLq';
import { DataType } from './dataType';
import { MonitoringType } from './monitoringType';


export interface WaterIntakeEntriesUpdateBody { 
    /**
     * The air entry value
     */
    value: number;
    /**
     * The air entry nit value
     */
    unit: string;
    belowLdLq: WaterIntakeEntriesUpdateBody.BelowLdLqEnum | null;
    operationCondition: OperationCondition;
    dataType: DataType;
    determinationType: DeterminationType;
    monitoringType: MonitoringType;
}
export namespace WaterIntakeEntriesUpdateBody {
    export type BelowLdLqEnum = 'LD' | 'LQ';
    export const BelowLdLqEnum = {
        LD: 'LD' as BelowLdLqEnum,
        LQ: 'LQ' as BelowLdLqEnum
    };
}


